export const Wordmark = ({ size = 22 }) => (
  <span style={{
    display: 'inline-block',
    fontFamily: 'var(--font-serif)',
    fontSize: size,
    letterSpacing: '-0.015em',
    lineHeight: 1,
    color: 'var(--ink)',
    whiteSpace: 'nowrap',
  }}>
    {'ventyv'}
    <span style={{ position: 'relative', display: 'inline-block' }}>
      {'ı'}
      <svg aria-hidden="true" viewBox="0 0 24 24" style={{
        position: 'absolute',
        left: '50%',
        top: '-0.32em',
        transform: 'translateX(-50%)',
        width: '0.46em',
        height: '0.46em',
        color: 'var(--primary-strong)',
        overflow: 'visible',
        pointerEvents: 'none',
      }}>
        <path fill="currentColor" d="M12 1.5l2.85 6.95 7.4.6-5.65 4.95 1.8 7.25L12 17.4 5.6 21.25l1.8-7.25L1.75 9.05l7.4-.6L12 1.5z"/>
      </svg>
    </span>
    {'p'}
  </span>
);

export const LogoMark = Wordmark;
